export const IMAGE_ROTATE_STEP = 90;
export const IMAGE_MAX_WIDTH = 300;
export const IMAGE_MAX_HEIGHT = 200;
export const EMPTY_IMAGE_SIZE = { width: 0, height: 0};

export type ImageSize = {
    width: number;
    height: number;
};

export type FittedImageSize = {
    boxWidth: number;
    boxHeight: number;
    renderWidth: number;
    renderHeight: number;
};

export const getNextImageRotation = (rotation: number): number =>
    (rotation + IMAGE_ROTATE_STEP) % 360;

export const getFittedImageSize = (imageSize: ImageSize, rotation: number): FittedImageSize => {
    const { width, height } = imageSize;

    if (!width || !height) {
        return {
            boxWidth: IMAGE_MAX_WIDTH,
            boxHeight: IMAGE_MAX_HEIGHT,
            renderWidth: IMAGE_MAX_WIDTH,
            renderHeight: IMAGE_MAX_HEIGHT
        };
    }

    const isSideRotated = rotation === IMAGE_ROTATE_STEP || rotation === IMAGE_ROTATE_STEP * 3;
    const rotatedWidth = isSideRotated ? height : width;
    const rotatedHeight = isSideRotated ? width : height;
    const ratio = Math.min(IMAGE_MAX_WIDTH / rotatedWidth, IMAGE_MAX_HEIGHT / rotatedHeight, 1);

    return {
        boxWidth: Math.round(rotatedWidth * ratio),
        boxHeight: Math.round(rotatedHeight * ratio),
        renderWidth: Math.round(width * ratio),
        renderHeight: Math.round(height * ratio)
    };
};